import { AITrace } from "../models/aiTrace";
import axiosConfig from "./axiosConfig";

export interface ErrorAnalysisRequest {
  logPayload?: Record<string, unknown>;
  config?: Record<string, unknown>;
  forceRefresh?: boolean;
}

export interface ErrorAnalysisResponse {
  summary?: string;
  details?: string;
  proposed_config?: Record<string, unknown> | null;
  proposed_config_rationale?: string | null;
  tool_trace?: Array<Record<string, unknown>>;
  // Complete AI interaction trace (system prompt, user prompt, thinking, every turn,
  // tool calls/results) for the operator-facing AITraceViewer.
  trace?: AITrace | null;
  usage?: Record<string, number>;
  cached?: boolean;
  // The error coach now runs as an LRO (its Bedrock loop exceeds the 30s API
  // Gateway budget). The kickoff returns either:
  //   - a cached analysis synchronously: { ...analysisFields, status: "completed" }
  //   - an LRO handle to poll: { operationKey, status: "pending" | "running" }
  // The api-client's runErrorAnalysisAndAwait hook hides this by polling
  // /async_status and resolving with the final analysis fields either way.
  operationKey?: string;
  status?: "pending" | "running" | "completed" | "failed";
  // Present when the analysis itself can't run (e.g. Bedrock not configured).
  error?: string;
}

const postHhDataTempErrorAnalysis = async (
  authToken: string,
  fileGuid: string,
  request: ErrorAnalysisRequest
): Promise<ErrorAnalysisResponse> => {
  const { data } = await axiosConfig.post(
    `/hh_data/temp/${fileGuid}/error_analysis`,
    request,
    {
      headers: { Authorization: `Bearer ${authToken}` },
    }
  );
  return data;
};

export default postHhDataTempErrorAnalysis;
